var pdfjsLib = require("pdf_js");
require("pdf_js_worker");
require("pdf_js_worker_entry");

const scanForPdfNotes = () => {
    $(".pdfViewer").each((i, pdfWrapperElm) => {
        const pdfWrapper = $(pdfWrapperElm);

        let pageNum = 1;
        let pageRendering = false;
        let pageNumPending = null;
        let pdfDoc = null;

        const canvas = pdfWrapper.find(".pdfCanvas")[0];
        const textContainer = pdfWrapper.find(".textLayer")[0];
        const prevElm = pdfWrapper.find(".pdfPrev")[0];
        const nextElm = pdfWrapper.find(".pdfNext")[0];
        const pageNumElm = pdfWrapper.find(".pdfPageNum")[0];
        const pageCountElm = pdfWrapper.find(".pdfPageCount")[0];
        const spinnerElm = pdfWrapper.find(".pdf-spinner-container")[0];
        const ctx = canvas.getContext('2d');

        const pdfUrl = canvas.dataset.pdfUrl;
        const documentId = canvas.dataset.documentId;

        const renderPage = (num) => {
            pageRendering = true;

            pdfDoc.getPage(num).then((page) => {
                const viewport = page.getViewport({ scale: 2 });
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                const renderContext = {
                    canvasContext: ctx,
                    viewport: viewport
                };

                page.render(renderContext).promise.then(() => {
                    pageRendering = false;

                    if (pageNumPending !== null) {
                        renderPage(pageNumPending);
                        pageNumPending = null;
                    }
                }).then(() => {
                    return page.getTextContent();
                }).then((textContent) => {
                    textContainer.innerHTML = '';
                    textContainer.style.left = `${canvas.offsetLeft}px`;
                    textContainer.style.top = `${canvas.offsetTop}px`;

                    const actualScale = 2 * canvas.offsetWidth / viewport.width;
                    const textLayerViewport = page.getViewport({ scale: actualScale });

                    updateRerenderCondition(canvas.offsetWidth);

                    pdfjsLib.renderTextLayer({
                        textContent: textContent,
                        container: textContainer,
                        viewport: textLayerViewport,
                        textDivs: []
                    });
                });
            });

            pageNumElm.textContent = num;
        }

        const queueRenderPage = (num) => {
            if (pageRendering) {
                pageNumPending = num;
            } else {
                renderPage(num);
            }
        }

        const onPrevPage = () => {
            if (pageNum <= 1) {
                return;
            }
            pageNum--;
            queueRenderPage(pageNum);
        }

        prevElm.addEventListener('click', onPrevPage);
        prevElm.addEventListener('keypress', (e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                onPrevPage();
                e.preventDefault();
            }
        });

        const onNextPage = () => {
            if (pageNum >= pdfDoc.numPages) {
                return;
            }
            pageNum++;
            queueRenderPage(pageNum);
        }

        nextElm.addEventListener('click', onNextPage);
        nextElm.addEventListener('keypress', (e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                onNextPage();
                e.preventDefault();
            }
        });

        const loadPdf = () => {
            pdfjsLib.getDocument(pdfUrl).promise.then((pdfDoc_) => {
                pdfDoc = pdfDoc_;
                pageCountElm.textContent = pdfDoc.numPages;
                renderPage(pageNum);
                removeSpinnerAndShowCanvas();
            }).catch(() => {
                const pdfLinkId = `#pdf-link${documentId}`;
                $(pdfLinkId).remove();
            });
        }

        const removeSpinnerAndShowCanvas = () =>  {
            $(canvas).show();
            $(spinnerElm).hide();
        }

        const updateRerenderCondition = (currentCanvasWidth) => {
            $(window).resize(()=> {
                if (canvas.offsetWidth !== currentCanvasWidth && !pageRendering) {
                    renderPage(pageNum);
                }
            });
        }

        new MutationObserver((mutations) => {
            for (let index = 0; index < mutations.length; index++) {
                const mutation = mutations[index];
                if (mutation.type === "attributes" && mutation.attributeName === "class" && mutation.target.classList.contains("isVisible")) {
                    loadPdf();
                }
            }
        }).observe(pdfWrapper.parents(".punktrow")[0], {
            attributes: true
        });
    });
}

document.scanForPdfNotes = scanForPdfNotes;



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/pdfViewer.js
// module id = 147
// module chunks = 4